import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import moment from "moment";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from '../../presentational/table-pagination-actions';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import AuthHelper from '../../../libraries/auth-helper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { history } from '../../../shared/configure-store';
import { toast, ToastContainer } from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import language from '../../../libraries/label-lang';
import { bindActionCreators } from 'redux';
import { RootActions } from '../../../shared/root-action';
import { connect } from 'react-redux';

class Orders extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            showDialog: false,
            idDelete: '',
            currDelete: '',

            orderBy: '',
            sortedBy: '',
            searchBy: '',

            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,

            warehouses: [],

            userName: '',
            statusFilter: [],
            statusPast: false,
            classes: [],
            plans: [],
        };
    }

    componentDidMount() {

        document.title = 'Fresh Factory - Orders';
        let data = AuthHelper.getProfile();

        this.setState({
            data: data,
        }, () => this.__fetchData(false));

    };

    __fetchData = (update) => {
        /*  this.setState({
                  loading: true,
              }
          );*/

        let page = update ? parseInt(this.state.currentPage + 1) : this.state.currentPage;

        let sort = this.state.orderBy ? '&orderBy=' + this.state.orderBy + '&sortedBy=' + this.state.sortedBy : '';
        let search = this.state.searchBy ? '&search=' + this.state.searchBy : '';

        let route = '';

        if (search) {
            route = '/orders?limit=' + this.state.perPage + sort + search;
        } else {
            route = '/orders?limit=' + this.state.perPage + '&page=' + page + sort + search;
        }

        Api.get(route).then(resp => {
            if (resp.data) {

                this.setState({
                    rows: resp.data,
                    perPage: resp.meta.pagination.per_page,
                    currentPage: resp.meta.pagination.current_page,
                    currentPageTable: resp.meta.pagination.current_page - 1,
                    total: resp.meta.pagination.total,
                    loading: false,
                })

            }
        }).catch(err => {
            console.log(err);

            this.setState({
                loading: true,
            }
            );

        });
    };

    handleChange(e, prop) {

        this.setState({

            [prop]: e.target.value

        })

    };


    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row.id,
            currDelete: row.name,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog: false,
        })
    };

    handleDelete = () => {

        if (this.state.idDelete) {
            Api.delete('/orders/' + this.state.idDelete, '', false).then(resp => {

                this.setState({
                    showDialog: false,
                }
                );

                this.showMessage(true, 'Successfully deleted');
                this.__fetchData(false);

            }).catch(err => {

                this.setState({
                    showDialog: false
                }
                );

                this.showMessage(true, 'Successfully deleted');
                this.__fetchData(false);
            });
        }
    };

    handleGo = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if (status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        } else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleSearch = () => {
        this.__fetchData(false);
    };
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(false);
        }
    };

    handleSort = (val) => {

        let sortedBy = this.state.sortedBy;

        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            if (sortedBy && sortedBy === 'asc') {
                sortedBy = 'desc';
            } else {
                sortedBy = 'asc';
            }
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage: newPage,
            currentPageTable: newPage,
            loading: true,
        }, () => {
            this.__fetchData(true);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage: parseInt(event.target.value, 10),
            currentPage: 1,
            loading: true,
        }, () => {
            this.__fetchData(false);
        });
    };


    render() {
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>{text.label_orders}</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>{text.label_orders}
                    <Button
                        variant='contained'
                        color='primary'
                        className='float-right mb-3'
                        onClick={() => this.handleGo('/orders/add')}
                    >
                        {text.button_add} {text.label_orders}
                    </Button>
                </h2>

                <div className='clearfix'> </div>
                <div className='table-wrapper'>
                    <Table className='table-list' size='small' >
                        <TableHead>
                            <TableRow>
                                <TableCell className='clickable' onClick={() => this.handleSort('orderId')} >{text.label_order_code}
                                    {this.state.orderBy === 'orderId' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('createdAt')} >{text.label_order_date}
                                    {this.state.orderBy === 'createdAt' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('recipientAddress')} >{text.label_address}
                                    {this.state.orderBy === 'recipientAddress' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('recipientName')} >{text.label_receiver}
                                    {this.state.orderBy === 'recipientName' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('recipientPhoneNumber')} >{text.label_receiver_phone}
                                    {this.state.orderBy === 'recipientPhoneNumber' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('platform')} >{text.label_platform}
                                    {this.state.orderBy === 'platform' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('logisticCompany')} >{text.label_logistic}
                                    {this.state.orderBy === 'logisticCompany' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.loading ? (
                                <TableRow>
                                    <TableCell colSpan={8} align='center' className='py-5'>
                                        <CircularProgress color='primary' />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                    this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={8} style={{ textAlign: 'center' }}>{text.label_no}</TableCell>
                                        </TableRow>
                                    ) : (
                                            this.state.rows.map(row => (
                                                <TableRow
                                                    key={row.id}
                                                    selected={row.selected}>
                                                    <TableCell>{row.orderId === null ? '' : row.orderId}</TableCell>
                                                    <TableCell>{row.createdAt === null ? '' : moment(row.createdAt).format('DD MMM YYYY')}</TableCell>
                                                    <TableCell>{row.recipientAddress === null ? '' : row.recipientAddress}</TableCell>
                                                    <TableCell>{row.recipientName === null ? '' : row.recipientName}</TableCell>
                                                    <TableCell>{row.recipientPhoneNumber === null ? '' : row.recipientPhoneNumber}</TableCell>
                                                    <TableCell>{row.platform === null ? '' : row.platform}</TableCell>
                                                    <TableCell>{row.logisticCompany === null ? '' : row.logisticCompany}</TableCell>
                                                    <TableCell>{row.status === null ? '' : coverName(row.status, this.props.toggle_set_lang === 'indo')}</TableCell>
                                                </TableRow>
                                            ))
                                        )
                                )}

                        </TableBody>
                    </Table>
                </div>

                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component='div'
                    count={this.state.total}
                    rowsPerPage={this.state.perPage}
                    page={this.state.currentPageTable}
                    backIconButtonProps={{
                        'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'next page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>DELETE PROJECT: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>{text.text_delete}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleClose}
                        >
                            {text.button_cancel}
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton && 'disabled'}
                        >
                            {text.button_delete}{this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i>}
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Orders));


const coverName = (status, bahasa) => {
    if (!bahasa) return status

    switch (status.toLowerCase()) {
        case 'unprocess': return 'Belum Diproses'
        case 'process': return 'DiProses'
        case 'packing': return 'Sedang Dikemas'
        case 'waiting': return 'Menunggu Diambil'
        case 'pickup': return 'Sudah Diambil'
        default: return status
    }
}

